import * as React from "react";
import SectionHeading from "src/components/general/SectionHeading";
import LibrarySign from "./LibrarySign";
import { IConnectedModuleProps, IConnectedModuleState } from "src/interfaces";
import { defaultYear } from "src/constants/ApiSettings";
import { connect } from "react-redux";

class Libraries extends React.PureComponent<
  IConnectedModuleProps,
  IConnectedModuleState
> {
  constructor(props: IConnectedModuleProps) {
    super(props);

    const selectedYear = defaultYear;

    this.state = { selectedYear };
  }

  public handleYearChange = (value: string) => {
    this.setState({ selectedYear: value });
  };

  public render() {
    return (
      <React.Fragment>
        <div className="container" id="libraries">
          <div className="row my-4">
            <div className="w-full">
              <SectionHeading
                heading="Servicing your local libraries"
                alignment="left"
                yearPicker={ this.handleYearChange }
                year={ this.state.selectedYear }
                learnMore={ "libraryLoansPerCapita" }
                councilSays={ "libraryLoansPerCapitaCouncilSays" }
                inverse={ true }
              />
              <div className="w-full lg:w-1/2">
                <p className="text-white pt-8">
                  This is the average number of library visits, loans and programs attended for each person residing in your council area.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* MobileReplace */}
        <div id="localLibraries">
          <div className="container">
            <div className="row">
              <div className="w-full">
                <div className="w-full sm:w-3/4 md:w-3/4 lg:w-1/2">
                  <LibrarySign
                    councils={this.props.councils}
                    year={this.state.selectedYear}
                    activeTab={ 1 }
                    dropdownOpen={ false }
                   />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ./MobileReplace */}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any) => ({
  defaultYear:
    state.selectables.years.length > 0 ? state.selectables.years[0] : null,
  councils: state.selected.councils,

});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Libraries);



// WEBPACK FOOTER //
// ./src/components/report/councilExpenditure/Libraries/index.tsx